import { useDispatch, useSelector } from "react-redux";
import { setEliminarEvento, setLimpiarTemporales, setSeleccionarEvento } from "../../../store/Eventos/eventoSlice";
import { useNavigate } from "react-router-dom";
import { hotelesOpciones } from "../../../hook/Arreglos";
import "../../css/ColorTable.css";
import Swal from "sweetalert2";

export const ListaEventoTemporal = ({ type }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { eventosSeleccionados } = useSelector((state) => state.evento);

    // No renderizar si no hay eventos seleccionados.
    if (!eventosSeleccionados?.length) return null;

    // Función genérica para mostrar confirmaciones.
    const mostrarConfirmacion = (titulo, texto, callback) => {
        Swal.fire({
            title: titulo,
            text: texto,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí Generar firme",
            cancelButtonText: "Cancelar",
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) callback();
        });
    };

    // Acciones principales.
    const eliminarEvento = (idTemporal) => dispatch(setEliminarEvento({ idTemporal }));
    const limpiarEventos = () => dispatch(setLimpiarTemporales());
    const navegarCrearEvento = () => navigate(`/evento/crear`);

    // Obtener el nombre del hotel dado su ID.
    const obtenerNombreHotel = (idHotel) => hotelesOpciones.find((opcion) => opcion.value === idHotel?.toString())?.label || "No encontrado";

    // Formatear fechas al formato de 12 horas (AM/PM).
    const formatearFecha = (fecha) =>
        fecha
            ? new Date(fecha).toLocaleString("es-ES", {
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  weekday: "long",
              })
            : "N/D";
    const manejarSeleccionFila = (evento) => {
        dispatch(setSeleccionarEvento({ idTemporal: evento.idTemporal, fechaB: evento.start, hotel: evento.hotelid }));
    };

    return (
        <div className="table-card card">
            {/* Encabezado */}
            <div className="d-flex align-items-center justify-content-start py-3 card-header">
                <h5 className="mb-0 me-auto">Lista de eventos Temporales</h5>
            </div>

            {/* Tabla de eventos */}
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table table-hover hoverable-table" id="pc-dt-simple">
                        <thead>
                            <tr>
                                <th>Título</th>
                                <th>Salón</th>
                                <th>Hotel</th>
                                <th>Fecha Hora Inicio</th>
                                <th>Fecha Hora Final</th>
                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {eventosSeleccionados
                                .slice() // Evitar mutaciones.
                                .sort((a, b) => {
                                    const startComparison = new Date(a.start) - new Date(b.start);
                                    if (startComparison !== 0) return startComparison; // Si las fechas de inicio son diferentes.
                                    return new Date(a.end) - new Date(b.end); // Ordenar por fecha final si las de inicio son iguales.
                                })
                                .map((evento, index) => (
                                    <tr
                                        key={index}
                                        onClick={() => manejarSeleccionFila(evento)}
                                        style={{
                                            backgroundColor: evento.color === "#349e9e" ? evento.color : "inherit",
                                        }}
                                    >
                                        <td style={{ color: evento.color === "#349e9e" ? "#ffffff" : "inherit" }}>{evento.title || "N/A"}</td>
                                        <td style={{ color: evento.color === "#349e9e" ? "#ffffff" : "inherit" }}>{evento.nombreSalon || "N/A"}</td>
                                        <td style={{ color: evento.color === "#349e9e" ? "#ffffff" : "inherit" }}>{obtenerNombreHotel(evento.hotelid)}</td>
                                        <td style={{ color: evento.color === "#349e9e" ? "#ffffff" : "inherit" }}>{formatearFecha(evento.start)}</td>
                                        <td style={{ color: evento.color === "#349e9e" ? "#ffffff" : "inherit" }}>{formatearFecha(evento.end)}</td>
                                        <td>
                                            <a className="avtar avtar-xs btn-link-secondary" onClick={() => eliminarEvento(evento.idTemporal)} style={{ color: evento.color === "#349e9e" ? "#ffffff" : "inherit" }}>
                                                <i className="ti ti-trash f-20"></i>
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>

                {/* Botones de acción */}
                {type === "mostrar"  && (
                    <div className="d-flex align-items-center justify-content-start py-3 card-header">
                        <button className="btn btn-dark me-2" onClick={() => mostrarConfirmacion("¿Estás seguro de crear el evento en firme?", "Esta acción te llevará a la vista para continuar con el proceso de creación del evento en firme.", navegarCrearEvento)}>
                            Crear evento Firme
                        </button>
                        <button className="btn btn-danger" onClick={() => mostrarConfirmacion("¿Estás seguro?", "Esta acción limpiará la lista de eventos temporales.", limpiarEventos)}>
                            Limpiar eventos temporales
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
